module.exports = __webpack_public_path__ + "img/yame2.11ef26a5.jpg";